import { EnvelopeSimple, MapPin, Phone, User as UserIcon } from "@phosphor-icons/react";

export default function CustomerDetailCard({ order }) {
  const addr = order.customer_address || {};
  const fullAddr = [addr.address, addr.number, addr.complement].filter(Boolean).join(", ");
  return (
    <div className="border border-black bg-white" data-testid="customer-detail">
      <div className="border-b border-black p-4 flex items-center gap-2"><UserIcon size={16} weight="bold" /><div className="overline text-zinc-500">DETALHES DO CLIENTE</div></div>
      <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        {order.customer_email && <div className="flex items-center gap-2"><EnvelopeSimple size={14} className="text-zinc-400" /> {order.customer_email}</div>}
        {order.customer_phone && <div className="flex items-center gap-2"><Phone size={14} className="text-zinc-400" /> <span className="font-mono">{order.customer_phone}</span></div>}
        {fullAddr && <div className="md:col-span-2 flex items-start gap-2"><MapPin size={14} className="mt-0.5 text-zinc-400" /> <span>{fullAddr}{addr.neighborhood && ` · ${addr.neighborhood}`}{addr.city && ` · ${addr.city}/${addr.state}`}{addr.zipcode && ` · CEP ${addr.zipcode}`}</span></div>}
        {!order.customer_email && !order.customer_phone && !fullAddr && (
          <div className="text-zinc-500 col-span-2 text-xs leading-relaxed">
            {order.marketplace_source ? (
              <>
                <strong>{order.marketplace_source}</strong> não compartilha e-mail/telefone/endereço do cliente por padrão (LGPD). Para gerar etiqueta, use a integração do próprio Bling ou consulte o pedido no painel do marketplace{order.store_number && <> (nº <span className="font-mono">{order.store_number}</span>)</>}.
              </>
            ) : (
              "Este pedido não trouxe e-mail, telefone ou endereço. Complete o cadastro do contato no Bling e use \"Re-importar Itens Faltantes\" nas configurações para sincronizar."
            )}
          </div>
        )}
      </div>
    </div>
  );
}
